/**
 * CA 订单网上支付 · 收银台表单跳转。
 *
 * 依据接口文档 §5.1：signOrder 返回 CaPayInfoVo 后，前端将**除 url / mobileUrl / status
 * 以外的全部字段**作为隐藏域构造表单，POST 到支付平台地址 url，在收银台完成支付。
 * （与主站 @/common/pay/pay 的区别：主站版写死字段清单且 serviceCharge 固定为 '0'、
 *   漏传 paymentType；这里按文档全量透传，后端调整字段时前端不用跟着改。）
 *
 * @param {object} payInfo CaPayInfoVo（signOrder 接口返回的 data）
 * @returns {boolean} 是否成功打开收银台（payInfo 无 url 时不跳转、返回 false）
 */
export function payCaOrder(payInfo) {
  if (!payInfo || !payInfo.url) return false
  const form = document.createElement('form')
  form.method = 'post'
  form.action = payInfo.url
  form.target = '_blank'
  form.style.display = 'none'
  Object.keys(payInfo).forEach((key) => {
    if (key === 'url' || key === 'mobileUrl' || key === 'status') return
    const value = payInfo[key]
    if (value === undefined || value === null) return
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = value
    form.appendChild(input)
  })
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
  return true
}

/**
 * 「已发起支付」标记（sessionStorage，按 orderId）。
 *
 * 收银台在第三方新窗口完成支付，本页无法直接感知支付动作；在用户真正点了支付
 * （申请页确认下单 / 订单详情「立即支付」）时打标，订单列表页凭标记弹「支付结果
 * 确认」弹框——避免刚登录、列表里本就有历史待付款订单时误弹。标记消费即删，
 * 同一订单只提醒一次。
 */
const PAY_INITIATED_KEY = (orderId) => 'ca-pay-initiated-' + orderId

export function markPayInitiated(orderId) {
  if (!orderId) return
  sessionStorage.setItem(PAY_INITIATED_KEY(orderId), '1')
}

export function consumePayInitiated(orderId) {
  if (!orderId) return false
  const hit = sessionStorage.getItem(PAY_INITIATED_KEY(orderId))
  if (hit) sessionStorage.removeItem(PAY_INITIATED_KEY(orderId))
  return Boolean(hit)
}
